// Light-theme tag chips: stronger tint backgrounds + dark text for legibility.
const vibeColors = {
  adventure: 'bg-orange-100 text-orange-800',
  beaches:   'bg-cyan-100 text-cyan-800',
  nightlife: 'bg-purple-100 text-purple-800',
  romantic:  'bg-pink-100 text-pink-800',
  food:      'bg-amber-100 text-amber-800',
  culture:   'bg-blue-100 text-blue-800',
  iconic:    'bg-yellow-100 text-yellow-800',
  affordable:'bg-green-100 text-green-800',
  energy:    'bg-red-100 text-red-800',
  luxury:    'bg-violet-100 text-violet-800',
  glamour:   'bg-fuchsia-100 text-fuchsia-800',
};

export default function VibeTags({ tags = [], size = 'sm' }) {
  const sizeClass = size === 'xs' ? 'text-[10px] px-1.5 py-0.5' : 'text-xs px-2 py-0.5';
  return (
    <div className="flex flex-wrap gap-1">
      {tags.map(tag => (
        <span
          key={tag}
          className={`${vibeColors[tag] || 'bg-brand-ink/10 text-brand-ink/70'} ${sizeClass} rounded-full font-semibold`}
        >
          {tag}
        </span>
      ))}
    </div>
  );
}
